// extracted by mini-css-extract-plugin
export default {"titleBar":"CustomAccordion_titleBar__HM9Jj","semiBold":"CustomAccordion_semiBold__OXqYL"};